var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExerciseGrammar = function SvgExerciseGrammar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    filter: "url(#exercise-grammar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.94 3h.12c2.449 0 4.369 0 5.891.165 1.554.168 2.814.518 3.889 1.3a7.7 7.7 0 0 1 1.696 1.695c.78 1.075 1.13 2.335 1.299 3.889.165 1.523.165 3.442.165 5.89v.121c0 2.449 0 4.369-.165 5.891-.168 1.554-.518 2.814-1.3 3.889a7.7 7.7 0 0 1-1.695 1.696c-1.075.78-2.335 1.13-3.889 1.299-1.523.165-3.442.165-5.89.165h-.121c-2.449 0-4.368 0-5.891-.165-1.554-.168-2.814-.518-3.889-1.3a7.7 7.7 0 0 1-1.696-1.695c-.78-1.075-1.13-2.335-1.299-3.889C3 20.428 3 18.51 3 16.061v-.121c0-2.449 0-4.368.165-5.891.168-1.554.518-2.814 1.3-3.889A7.7 7.7 0 0 1 6.16 4.464c1.075-.78 2.335-1.13 3.889-1.299C11.572 3 13.49 3 15.939 3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#exercise-grammar_svg__b)",
    strokeLinecap: "round",
    d: "M15.94 3h.12c2.449 0 4.369 0 5.891.165 1.554.168 2.814.518 3.889 1.3a7.7 7.7 0 0 1 1.696 1.695c.78 1.075 1.13 2.335 1.299 3.889.165 1.523.165 3.442.165 5.89v.121c0 2.449 0 4.369-.165 5.891-.168 1.554-.518 2.814-1.3 3.889a7.7 7.7 0 0 1-1.695 1.696c-1.075.78-2.335 1.13-3.889 1.299-1.523.165-3.442.165-5.89.165h-.121c-2.449 0-4.368 0-5.891-.165-1.554-.168-2.814-.518-3.889-1.3a7.7 7.7 0 0 1-1.696-1.695c-.78-1.075-1.13-2.335-1.299-3.889C3 20.428 3 18.51 3 16.061v-.121c0-2.449 0-4.368.165-5.891.168-1.554.518-2.814 1.3-3.889A7.7 7.7 0 0 1 6.16 4.464c1.075-.78 2.335-1.13 3.889-1.299C11.572 3 13.49 3 15.939 3Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#exercise-grammar_svg__c)",
    fillRule: "evenodd",
    d: "M13.333 8.333A3.667 3.667 0 0 0 9.667 12v1.333a1 1 0 0 0 2 0V12c0-.92.746-1.667 1.666-1.667H15v11.334h-1.667a1 1 0 1 0 0 2h5.334a1 1 0 0 0 0-2H17V10.333h1.667c.92 0 1.666.746 1.666 1.667v1.333a1 1 0 1 0 2 0V12a3.667 3.667 0 0 0-3.666-3.667z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "exercise-grammar_svg__b",
    x1: 3,
    x2: 29.013,
    y1: 3,
    y2: 28.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exercise-grammar_svg__c",
    x1: 16.107,
    x2: 36.811,
    y1: 26.933,
    y2: 10.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "exercise-grammar_svg__a",
    width: 75,
    height: 75,
    x: -21.5,
    y: -21.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_203_4854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_203_4854",
    result: "shape"
  })))));
};
export { SvgExerciseGrammar as ReactComponent };